module.exports = __webpack_public_path__ + "assets/modal-cat.15d446fb.svg";